"use strict";

function getRecentlyViewedProducts() {
  try {
    return JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
  } catch (e) {
    return [];
  }
}

if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      const list = this.querySelector("[data-recently-viewed-list]");
      if (!list) return;

      let items = getRecentlyViewedProducts();

      const maxItems = parseInt(this.dataset.productsToShow) || 4;

      items = items.slice(-maxItems).reverse();

      const handles = items.map(p => p.handle);

      Promise.all(
        handles.map(handle => {
          return fetch(`/products/${handle}?section_id=recently-viewed-item`)
            .then(res => res.text())
            .then(html => {
              const div = document.createElement("div");
              div.innerHTML = html;
              return div.firstElementChild;
            })
            .catch(() => null);
        })
      ).then(elements => {
        const valid = elements.filter(Boolean);

        if (!valid.length) {
          this.closest(".shopify-section").style.display = "none";
          return;
        }

        valid.forEach(el => list.appendChild(el));
      });
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}